var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { View } from 'react-native';
import { DateTimePicker, getTestId } from '@airtel/air-design-system';
import { convertToTimestamp } from './DateTimePickerWidgetUtils';
export var DateTimePickerWidgetComponent = props => {
  var id = props.id,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'DateTimePickerWidget' : _props$testID,
    _props$dateTimePicker = props.dateTimePickerProps,
    dateTimePickerProps = _props$dateTimePicker === void 0 ? {} : _props$dateTimePicker,
    onChangeMetaData = props.onChangeMetaData,
    onOpenMetaData = props.onOpenMetaData,
    onCloseMetaData = props.onCloseMetaData,
    onInvalidMetaData = props.onInvalidMetaData,
    onRangeChangeMetaData = props.onRangeChangeMetaData,
    onUserAction = props.onUserAction,
    restProps = __rest(props, ["id", "testID", "dateTimePickerProps", "onChangeMetaData", "onOpenMetaData", "onCloseMetaData", "onInvalidMetaData", "onRangeChangeMetaData", "onUserAction"]);
  return _jsx(View, Object.assign({}, getTestId(testID), restProps, {
    children: _jsx(DateTimePicker, Object.assign({}, getTestId(testID, 'date-time-picker'), dateTimePickerProps, {
      onChange: (dateEvent, date) => {
        if ((dateTimePickerProps === null || dateTimePickerProps === void 0 ? void 0 : dateTimePickerProps.mode) === 'date-range' && dateEvent[1] && onRangeChangeMetaData) {
          var startDate = dateEvent[0],
            endDate = dateEvent[1];
          var timeStamp = {
            startDate: startDate && convertToTimestamp(startDate),
            endDate: endDate && convertToTimestamp(endDate)
          };
          onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, onRangeChangeMetaData), {
            dateEvent,
            date,
            timeStamp
          });
        }
        onChangeMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onChangeMetaData), {
          dateEvent,
          date
        }));
      },
      onOpen: () => {
        onOpenMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onOpenMetaData)));
      },
      onClose: () => {
        onCloseMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onCloseMetaData)));
      },
      onInValidInput: () => {
        onInvalidMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onInvalidMetaData)));
      }
    }))
  }));
};
DateTimePickerWidgetComponent.genericRendererKey = 'AirDateTimePickerWidget';